export default "__VITE_ASSET__CyUJG$Pd__"